<div class="container mb-4">
  <div class="row justify-content-center">
    <h2 class="text-center mt-4">{{ 'byt_home_your_offers' | translate }}</h2>
  </div>
</div>
<div
  class="container mb-4 multiple-carousel px-2 px-md-1 py-1"
  *ngIf="list | async as packages; else loading">
  <ng-container *ngIf="isBrowser">
    <carousel
      [cellsToShow]="numberCells"
      [cellsToScroll]="1"
      *ngIf="packages.length"
      class="">
      <div
        class="carousel-cell p-1"
        *ngFor="let package of packages; let i = index"
        [routerLink]="['/trail', package.trail.slug, 'packages', package.slug]">
        <div
          class="card text-center"
          [ngClass]="{ 'special-package': package.is_special }">
          <app-corner-icon
            [appShowIfTrue]="package.is_special"></app-corner-icon>
          <img
            [defaultImage]="defaultImage"
            [lazyLoad]="package.images.list | getImageUrl"
            [alt]="package.descriptions?.title | getText : currLang" />
          <div class="card-content px-2 px-xl-4">
            <h3 class="card-title mb-4">
              {{ package.trail.name | translate }}
            </h3>
            <p>
              {{ package.descriptions?.title | getText : currLang }}<br />
              {{ package.descriptions?.price_info | getText : currLang }}
            </p>
          </div>
        </div>
      </div>
    </carousel>
  </ng-container>
</div>

<ng-template #loading>
  <div class="row vh-50 d-flex justify-content-center align-items-center">
    <div class="col-12">
      <app-spinner></app-spinner>
    </div>
  </div>
</ng-template>
